// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { Input } from "antd";
// import { MailFilled } from "@ant-design/icons";
// import ForgotPasswordImage from "../../Assets/GodrejLOGO.png";
// import "./ForgotPassword.css";
// import useInputs from "../../customhooks/useInputs";
// import ForgotPasswordFetch from "../../services/ForgotPassword";

// function ForgotPassword() {
//   let email = useInputs("");
//   const navigate = useNavigate();

//   const handleForgotPassword = async () => {
//     if (email.value === "") {
//       toast("Email is required");
//       return;
//     }
//     let data = await ForgotPasswordFetch({
//       email: email.value,
//     });
//     if (data === "Email is incorrect!") {
//       toast(data);
//       setTimeout(() => {
//         navigate("/");
//       }, 2000);
//     } else if (data.status === 200) {
//       toast(data.data);
//     }
//   };
//   return (
//     <>
//       <div style={{ position: "relative" }}>
//         <img
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             width: "40vh",
//             height: "10vh",
//             marginTop: "1vh",
//           }}
//           src={ForgotPasswordImage}
//           alt="Logo"
//         />
//       </div>

//       <div className="LoginDiv" style={{ height: "85vh" }}>
//         <div className="InputDiv">
//           <div className="InputDivText">
//             <h3>Forgot Password</h3>
//           </div>
//           <div className="InputDivInner">
//             <div className="Input">
//               <label>Email Address</label>
//               <Input
//                 required
//                 prefix={<MailFilled size="10vh" />}
//                 placeholder="Enter Your Email"
//                 value={email.value}
//                 onChange={email.onChange}
//               />
//             </div>
//             <div className="my-3">
//               <button
//                 type="button"
//                 class="btn btn-dark"
//                 onClick={handleForgotPassword}
//               >
//                 SEND LINK
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ForgotPassword;

import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Input } from "antd";
import { MailFilled } from "@ant-design/icons";
import ForgotPasswordImage from "../../Assets/GodrejLOGO.png";
import useInputs from "../../customhooks/useInputs";
import ForgotPasswordFetch from "../../services/ForgotPassword";

function ForgotPassword() {
  let email = useInputs("");
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    if (email.value === "") {
      toast("Email is required");
      return;
    }
    let data = await ForgotPasswordFetch({
      email: email.value,
    });
    if (data === "Email is incorrect!") {
      toast(data);
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } else if (data.status === 200) {
      toast(data.data);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      {/* Logo */}
      <div className="flex justify-center mb-6">
        <img
          className="w-48 h-auto sm:w-64"
          src={ForgotPasswordImage}
          alt="Logo"
        />
      </div>

      {/* Forgot Password Form */}
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <div className="text-center mb-4">
          <span className="text-xl font-bold text-blue-500">
            Forgot Password
          </span>
        </div>

        {/* Email Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            Email Address
          </label>
          <Input
            required
            prefix={<MailFilled />}
            placeholder="Enter Your Email"
            value={email.value}
            onChange={email.onChange}
            className="w-full"
          />
        </div>

        {/* Send Link Button */}
        <div className="flex items-center justify-center">
          <button
            type="button"
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg"
            onClick={handleForgotPassword}
          >
            SEND LINK
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
